import { RATE_LIMIT_PAGE_PATH } from '../consts'

export const redirectToRateLimit = () => {
  if (window.location.pathname !== RATE_LIMIT_PAGE_PATH) {
    window.location.replace(RATE_LIMIT_PAGE_PATH)
  }
}
